import http from '../http-common'
import TokenService from "./token.service";

class AuthService {
  login(user) {
    return http.post('/auth/login', {
      username: user.username,
      password: user.password
    })
    .then(response => {
      if (response.data.accessToken) {
        TokenService.setUser(response.data);
      }
      return response.data;
    });
  }

  logout() {
    TokenService.removeUser();
  }

  register(user) {
    return http.post('/auth/sign-up', user);
  }

  confirmAdmin(user_id) {
    return http.get('/auth/verify-email-admin/' + user_id)
  }
}

export default new AuthService();
